export default __webpack_public_path__ + "static/media/login_left_bg.95c235b4.png";